import cx from "classnames";
import React from "react";
import { IMediumModalProps } from "../../../types/interfaces";
import styles from "./mediumModal.module.scss";
import { Button, CloseIcon, HeadingContainer } from "@gataca/design-system/web";
import { gaColors } from "../../../assets/globalConstants";
import { useTranslation } from "react-i18next";

const MediumModal: React.FC<IMediumModalProps> = (props) => {
  const {
    title,
    primaryButton,
    secondaryButton,
    description,
    closableByBg,
    children,
    onClose,
  } = props;

  const { t } = useTranslation();

  return (
    <>
      <div
        className={styles.modal__bg}
        onClick={() => (closableByBg && onClose ? onClose() : undefined)}></div>
      <div className={styles.modal}>
        {/* Top container */}
        <div className={cx(styles.modal__topContainer)}>
          <HeadingContainer
            size={"small"}
            contentTextColor={"grey"}
            titleText={t(title)}
            contentText={t(description)}
          />

          {onClose ? (
            <div
              className={styles.modal__topContainer__closeButton}
              onClick={onClose}>
              <CloseIcon size="24" color={gaColors.neutral1000} />
            </div>
          ) : null}
        </div>

        {/* Content */}
        <div className={styles.modal__mainContainer}>{children}</div>

        {/* Bottom container */}
        {primaryButton || secondaryButton ? (
          <div className={styles.modal__bottomContainer}>
            <div className={styles.modal__bottomContainer__buttonsContainer}>
              {secondaryButton ? (
                <Button
                  style={"text"}
                  color={"purple"}
                  {...secondaryButton}
                  text={t(secondaryButton?.text)}
                  className={cx(styles.secondaryButton)}
                />
              ) : null}
              {primaryButton ? (
                <Button
                  style={"fill"}
                  color={"purple"}
                  containerStyle={{ borderWidth: 0 }}
                  {...primaryButton}
                  text={t(primaryButton?.text)}
                />
              ) : null}
            </div>
          </div>
        ) : null}
      </div>
    </>
  );
};

export default MediumModal;
